import { Entity } from '@core/entities/entity'
import { IPermitStatsByMonth } from './IPermitStatsByMonth'
import { plainToInstance } from 'class-transformer'

export class PermitStatsByMonth extends Entity<IPermitStatsByMonth> {
  month: string

  count: number

  public static new(payload: unknown): PermitStatsByMonth {
    const entity = plainToInstance(PermitStatsByMonth, payload)

    return entity
  }
}
